import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage.tsx';
import About from './About.tsx';
import Privacy from './pages/Privacy.tsx';
import Security from './pages/Security.tsx';
import Terms from './pages/Terms.tsx';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/security" element={<Security />} />
                <Route path="/terms" element={<Terms />} />
            </Routes>
        </Router>
    );
}

export default App;